// Badge colours extracted from Webflow — border + 20% opacity background per type
export const TYPE_BADGE: Record<
  string,
  { bg: string; border: string; text: string }
> = {
  Article: {
    bg: "rgba(60, 129, 143, 0.2)",
    border: "#3c818f",
    text: "#306772",
  },
  Download: {
    bg: "rgba(241, 165, 39, 0.2)",
    border: "#f1a527",
    text: "#c0841f",
  },
  Podcast: {
    bg: "rgba(227, 108, 37, 0.2)",
    border: "#e36c25",
    text: "#e36c25",
  },
  Video: { bg: "rgba(197, 65, 42, 0.2)", border: "#c5412a", text: "#c5412a" },
  Assessment: {
    bg: "rgba(72, 72, 71, 0.2)",
    border: "#484847",
    text: "#484847",
  },
  Collection: {
    bg: "rgba(249, 203, 163, 0.2)",
    border: "#f9cba3",
    text: "#c7a282",
  },
  "Resource Collection": {
    bg: "rgba(249, 203, 163, 0.2)",
    border: "#f9cba3",
    text: "#c7a282",
  },
};

export function ResourceBadge({ type }: { type: string }) {
  const badge = TYPE_BADGE[type];
  if (!badge) {
    return (
      <span className="font-medium text-muted-foreground text-sm uppercase tracking-wide">
        {type}
      </span>
    );
  }
  return (
    <span
      className="inline-flex items-center rounded-lg border px-2 py-0.5 font-semibold text-sm"
      style={{
        backgroundColor: badge.bg,
        borderColor: badge.border,
        color: badge.text,
      }}
    >
      {type}
    </span>
  );
}
